import React from 'react';

import { COLOR } from '@/theme/colors';
import { SVGIconProps } from '@/types/svg';

function RightArrowIcon({
    color = COLOR.black,
    height = 24,
    width = 24,
}: SVGIconProps) {
    return (
        <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 12H5m14 0-4 4m4-4-4-4"
            />
        </svg>
    );
}

export default RightArrowIcon;
